
export default class APIProxy {

  authHeaders = {
    'token': '',
    'email': '',
    'userFuzzyId': ''
  }

  getUserFuzzyId = () => {
    return this.authHeaders.userFuzzyId;
  }

  updateCredentialHeaders(credentials) {
    this.authHeaders = {
      'token': credentials.token,
      'email': credentials.email,
      'userFuzzyId': credentials.id,
    }
  }

 async  get(url, action) {
    await fetch(url, {
      headers: {
        ...this.authHeaders
      },
    })
      .then(response => response.json())
      .then(json => {
        action(json);
      });
  }

  async post(url, bodyParams, action) {
    await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        ...this.authHeaders
      },
      body: JSON.stringify(bodyParams)
    })
      .then(response => response.json())
      .then(json => {
        action(json);
      });
  }

  async query(url, queryString, variables) {
    return await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'access-control-allow-origin': '*',
        ...this.authHeaders
      },
      body: JSON.stringify({ query: queryString, variables })
    });
  }

  async mutate(url, mutationQueryString, variables) {
    return await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'access-control-allow-origin': '*',
        ...this.authHeaders
      },
      body: JSON.stringify({ query: mutationQueryString, variables })
    });
  }

   generateToken = async (url, bodyParams) => {
    const data = new URLSearchParams({ ...bodyParams });
     return await fetch(url, {
      method: 'POST',
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: data.toString()
    });


   }



  async asyncPost(url, bodyParams) {
    return await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'access-control-allow-origin': '*',
        ...this.authHeaders
      },
      body: JSON.stringify(bodyParams)
    });
  }

  async asyncDelete(url, bodyParams) {
    return await fetch(url, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'access-control-allow-origin': '*',
        ...this.authHeaders
      },
      body: JSON.stringify(bodyParams)
    });
  }

  async getAsync(url) {
    return await fetch(url, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'access-control-allow-origin': '*',
        ...this.authHeaders
      }
    }
    );
  }
}
